
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PageHeading extends Vue {
  @Prop()
  private heading!: string;
}
